// Utils
import cn from '../../../utils/cn';

// Domain
import {
  getCssCellOpacity,
  getEffectiveCellAlign,
  getEffectiveCellVerticalAlign,
} from '../../../domain/table/tableCellLayoutUseCase';

// Styles
import commonStyles from './TableCellCommon.module.css';
import directEditCommon from './DirectEditCommon.module.css';

/**
 * Full-cell flex shell: alignment + optional API background (fills td; value stays fit-content for row selection).
 * @param {TableCellValueObjectCustom | null | undefined} cellValue
 * @returns {{ className: string, style: import('react').CSSProperties | undefined }}
 */
export function getDirectEditShellProps(cellValue) {
  const align = getEffectiveCellAlign(cellValue);
  const verticalAlign = getEffectiveCellVerticalAlign(cellValue);
  const backgroundColor = cellValue?.backgroundColor ?? null;
  const opacity = getCssCellOpacity(cellValue?.opacity);
  const style = /** @type {import('react').CSSProperties} */ ({
    ...(backgroundColor ? { backgroundColor } : {}),
    ...(opacity !== undefined ? { opacity } : {}),
  });
  const hasStyle = Object.keys(style).length > 0;

  return {
    className: cn([
      directEditCommon['direct-edit-shell'],
      commonStyles[`cell-align-${align}`],
      verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      backgroundColor && commonStyles['cell-shell-with-background'],
    ]),
    style: hasStyle ? style : undefined,
  };
}

/**
 * @param {TableCellValueObjectCustom | null | undefined} cellValue
 * @returns {string}
 */
export function getDirectEditShellClassName(cellValue) {
  return getDirectEditShellProps(cellValue).className;
}
